import React, { Component } from "react";

import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import PreloaderLight from "./../../../shared/items/static/preloaderLight";
import { states } from "./../../../reducers/queriesStates";

import { withRestore } from "../../../shared/containers/containerRestore";

import styles from "./buttonRestoreSendMailWrapper.module.scss";

class ButtonRestoreSendMailWrapper extends Component {
  componentDidMount() {
    document.addEventListener("keydown", this.clickEnter);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.clickEnter);
  }

  clickEnter = (e) => {
    const { onSendMail, restore } = this.props;

    if (e.keyCode === 13) {
      onSendMail(restore.restoreItems);
    }
  };

  onRegistration() {
    const { onSendMail, restore } = this.props;
    onSendMail(restore.restoreItems);
  }

  render() {
    const { restore } = this.props;

    return (
      <ButtonPrimary handleClick={this.onRegistration.bind(this)}>
        {restore.sendEmailDataState === states.REQUEST ? (
          <div className={styles.container_preloader}>
            <PreloaderLight />
          </div>
        ) : (
          "Отправить ссылку"
        )}
      </ButtonPrimary>
    );
  }
}

export default withRestore(ButtonRestoreSendMailWrapper);
